<template>
    <div class="page-title-area bg-14">
        <div class="container">
            <div class="page-title-content">
                <h2>Services Style Three</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Services Style Three</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>